const componentsCommon=require("cb-components-common").default;
const request=componentsCommon.request;
export function login(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/login",
        method: "post",
        data: _params
    });
}

export function getInfo() {
    return request({
        url: "/ui-api/v1/info",
        method: "get"
    });
}

export function editInfo(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/info",
        method: "put",
        data: _params
    });
}

export function getRole(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/role",
        method: "get",
        data: _params
    });
}

export function editSubscription(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/subscription",
        method: "put",
        data: _params
    });
}

export function getResetPasswordLink(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/resetPasswordLink?email=" + _params,
        method: "get"
    });
}

export function resetPassword(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/resetPassword",
        method: "put",
        data: _params
    });
}

export function forgotPassword(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/forgotPassword",
        method: "put",
        data: _params
    });
}
